export const BANNER_TYPE_LANDSCAPE = 'LANDSCAPE';
export const BANNER_TYPE_PORTRAIT = 'PORTRAIT';
export const BANNER_TYPE_HERO = 'HERO';
